/* ==========================================================================
   X-Nutrition — Ficha de producto ONE FIT / XBODY (sections/xn-pdp.liquid)

   - Galería: el carril es un scroll horizontal con snap (el swipe en mobile
     es nativo); las miniaturas y el contador se sincronizan con el scroll.
   - Variantes: fichas por opción → variante; actualiza precio, ahorro, badge,
     botones, imagen y la URL (?variant=).
   - Compra por AJAX: "Agregar al carrito" se queda en la página y actualiza el
     contador del header; "Comprar ahora" agrega y va al checkout.
     Sin JS el <form> hace el POST normal (y "Comprar ahora" manda return_to).
   ========================================================================== */
(function () {
  'use strict';

  var raiz = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* Misma lógica que xn-labs.js: el header del tema no escucha eventos de
     carrito, así que el contador se actualiza a mano. */
  function actualizarContadorHeader(cantidad) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = cantidad;
    });
    var wrapper = document.querySelector('.header-cart');
    if (wrapper && !wrapper.querySelector('.cart-count') && cantidad > 0) {
      var span = document.createElement('span');
      span.className = 'cart-count';
      span.textContent = cantidad;
      wrapper.appendChild(span);
    }
    document.querySelectorAll('.btn_cart_count').forEach(function (el) {
      el.textContent = '( ' + cantidad + ' )';
    });
  }

  function initGaleria(root) {
    var track = root.querySelector('[data-xn-pdp-track]');
    if (!track) return null;
    var slides = track.querySelectorAll('.xn-pdp__slide');
    var thumbs = root.querySelectorAll('[data-xn-pdp-thumb]');
    var counter = root.querySelector('[data-xn-pdp-counter]');
    var actual = -1;

    function marcar(i) {
      if (i === actual) return;
      actual = i;
      thumbs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
      if (counter) counter.textContent = i + 1;
      // Si la miniatura activa quedó fuera de la columna, se trae a la vista
      // sin mover la página.
      var t = thumbs[i];
      if (t && t.parentNode) {
        var col = t.parentNode;
        if (t.offsetTop < col.scrollTop || t.offsetTop + t.offsetHeight > col.scrollTop + col.clientHeight) {
          col.scrollTop = t.offsetTop - 8;
        }
      }
    }

    function ir(i, suave) {
      if (i < 0 || i >= slides.length) return;
      track.scrollTo({ left: i * track.clientWidth, behavior: suave ? 'smooth' : 'auto' });
      marcar(i);
    }

    var pendiente = false;
    track.addEventListener(
      'scroll',
      function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(function () {
          pendiente = false;
          var w = track.clientWidth || 1;
          marcar(Math.round(track.scrollLeft / w));
        });
      },
      { passive: true }
    );

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        ir(parseInt(t.getAttribute('data-xn-pdp-thumb'), 10), true);
      });
    });

    // Posición inicial: la imagen de la variante elegida.
    var inicial = 0;
    thumbs.forEach(function (t, j) {
      if (t.classList.contains('is-active')) inicial = j;
    });
    if (inicial > 0) ir(inicial, false);
    else marcar(0);

    // Al cambiar el ancho (rotar el teléfono) el scroll queda a mitad de slide.
    window.addEventListener('resize', function () {
      track.scrollLeft = actual * track.clientWidth;
    });

    return {
      irAMedia: function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(mediaId)) {
            ir(i, true);
            return;
          }
        }
      },
    };
  }

  /* Devuelve los botones al estado previo al envío (habilitado o agotado). */
  function restaurar(root) {
    root.querySelectorAll('[data-xn-pdp-prev]').forEach(function (b) {
      var on = b.getAttribute('data-xn-pdp-prev') === 'on';
      b.removeAttribute('data-xn-pdp-prev');
      b.disabled = !on;
      var l = b.querySelector('[data-xn-pdp-label]');
      if (l) l.textContent = l.getAttribute(on ? 'data-label-on' : 'data-label-off');
    });
  }

  function initFicha(root) {
    if (root.dataset.xnPdpReady === 'true') return;
    root.dataset.xnPdpReady = 'true';
    root.classList.add('is-js');

    var galeria = initGaleria(root);
    var form = root.querySelector('[data-xn-pdp-form]');
    if (!form) return;

    var variantes = [];
    try {
      variantes = JSON.parse(root.querySelector('[data-xn-pdp-variants]').textContent);
    } catch (e) {}

    var idInput = form.querySelector('[data-xn-pdp-variant]');
    var qty = form.querySelector('input[name="quantity"]');
    var status = form.querySelector('[data-xn-pdp-status]');
    var fieldsets = Array.prototype.slice.call(form.querySelectorAll('[data-xn-pdp-option]'));
    var botones = Array.prototype.slice.call(root.querySelectorAll('[data-xn-pdp-buynow], [data-xn-pdp-add]'));

    fieldsets.forEach(function (fs) {
      fs.hidden = false;
    });

    /* ---------------- Cantidad ---------------- */
    form.addEventListener('click', function (e) {
      var b = e.target.closest('[data-xn-pdp-qty]');
      if (!b || !qty) return;
      var v = (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-xn-pdp-qty'), 10);
      qty.value = Math.max(1, v);
    });

    /* ---------------- Variantes ---------------- */
    function seleccion() {
      return fieldsets.map(function (fs) {
        var r = fs.querySelector('input:checked');
        return r ? r.value : null;
      });
    }

    function buscar(opciones) {
      for (var i = 0; i < variantes.length; i++) {
        var v = variantes[i];
        var ok = true;
        for (var j = 0; j < opciones.length; j++) {
          if (v.options[j] !== opciones[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return v;
      }
      return null;
    }

    /* Marca como agotados los valores que, combinados con lo elegido en las
       otras opciones, no tienen ninguna variante disponible. */
    function marcarDisponibles(opciones) {
      fieldsets.forEach(function (fs, idx) {
        fs.querySelectorAll('input').forEach(function (input) {
          var prueba = opciones.slice();
          prueba[idx] = input.value;
          var hay = variantes.some(function (v) {
            if (!v.available) return false;
            for (var j = 0; j < prueba.length; j++) {
              if (v.options[j] !== prueba[j]) return false;
            }
            return true;
          });
          input.closest('.xn-pdp__chip').classList.toggle('is-unavailable', !hay);
        });
      });
    }

    function setTexto(sel, texto) {
      root.querySelectorAll(sel).forEach(function (el) {
        el.textContent = texto || '';
        el.hidden = !texto;
      });
    }

    function aplicar(v) {
      if (!v) {
        botones.forEach(function (b) {
          b.disabled = true;
          var l = b.querySelector('[data-xn-pdp-label]');
          if (l) l.textContent = 'No disponible';
        });
        return;
      }
      if (idInput) idInput.value = v.id;

      root.querySelectorAll('[data-xn-pdp-amount]').forEach(function (el) {
        el.textContent = v.price;
      });
      setTexto('[data-xn-pdp-compare]', v.compare);
      var save = root.querySelector('[data-xn-pdp-save]');
      if (save) {
        save.hidden = !v.save;
        save.querySelector('[data-xn-pdp-save-amount]').textContent = v.save || '';
      }
      var off = root.querySelector('[data-xn-pdp-off]');
      if (off) {
        off.hidden = !v.pct;
        off.querySelector('[data-xn-pdp-off-pct]').textContent = v.pct;
      }

      botones.forEach(function (b) {
        b.disabled = !v.available;
        var l = b.querySelector('[data-xn-pdp-label]');
        if (l) l.textContent = l.getAttribute(v.available ? 'data-label-on' : 'data-label-off');
      });

      fieldsets.forEach(function (fs, idx) {
        var out = fs.querySelector('[data-xn-pdp-option-value]');
        if (out) out.textContent = v.options[idx];
      });

      if (galeria) galeria.irAMedia(v.media);

      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      }
    }

    fieldsets.forEach(function (fs, idx) {
      fs.addEventListener('change', function () {
        var opciones = seleccion();
        var v = buscar(opciones);
        if (!v) {
          // La combinación no existe (ej.: un sabor que sólo viene en un
          // tamaño): se toma la primera variante con el valor recién elegido,
          // priorizando las disponibles, y se acomodan las otras fichas.
          var conValor = variantes.filter(function (x) {
            return x.options[idx] === opciones[idx];
          });
          v =
            conValor.filter(function (x) {
              return x.available;
            })[0] || conValor[0];
          if (v) {
            fieldsets.forEach(function (otro, j) {
              var r = otro.querySelector('input[value="' + CSS.escape(v.options[j]) + '"]');
              if (r) r.checked = true;
            });
            opciones = v.options.slice();
          }
        }
        marcarDisponibles(opciones);
        aplicar(v);
      });
    });
    if (fieldsets.length) marcarDisponibles(seleccion());

    /* ---------------- Compra ---------------- */
    var ultimo = null;
    botones.forEach(function (b) {
      b.addEventListener('click', function () {
        ultimo = b;
      });
    });

    function mostrar(msg, error, conLink) {
      if (!status) return;
      status.className = 'xn-pdp__status' + (error ? ' is-error' : '');
      status.textContent = msg;
      if (conLink) {
        status.appendChild(document.createTextNode(' '));
        var a = document.createElement('a');
        a.href = raiz + 'cart';
        a.textContent = 'Ver carrito';
        status.appendChild(a);
      }
    }

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      var boton = e.submitter || ultimo;
      var comprar = !!(boton && boton.hasAttribute('data-xn-pdp-buynow'));
      e.preventDefault();

      botones.forEach(function (b) {
        b.setAttribute('data-xn-pdp-prev', b.disabled ? 'off' : 'on');
        b.disabled = true;
      });
      var label = boton && boton.querySelector('[data-xn-pdp-label]');
      if (label) label.textContent = comprar ? 'Procesando…' : 'Agregando…';
      mostrar('', false);

      var datos = new FormData(form);
      datos.delete('return_to');

      fetch(raiz + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: datos,
      })
        .then(function (r) {
          return r.json().then(function (j) {
            if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar al carrito.');
            return j;
          });
        })
        .then(function () {
          if (comprar) {
            window.location.href = '/checkout';
            return 'redirect';
          }
          return fetch(raiz + 'cart.js')
            .then(function (r) {
              return r.json();
            })
            .then(function (cart) {
              actualizarContadorHeader(cart.item_count);
              mostrar('Listo, se agregó al carrito.', false, true);
            });
        })
        .catch(function (err) {
          mostrar(err.message, true);
        })
        .then(function (res) {
          if (res === 'redirect') return;
          restaurar(root);
        });
    });

    if (root.querySelector('[data-xn-pdp-bar]')) {
      document.body.classList.add('xn-pdp-has-bar');
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-xn-pdp]').forEach(initFicha);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  // Volver con "atrás" desde el checkout: la página sale del bfcache con los
  // botones todavía en "Procesando…".
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-xn-pdp]').forEach(restaurar);
  });
})();
